import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
  SubMenu,
} from "react-pro-sidebar";
import { ImNewspaper } from "react-icons/im";
import {
  FiHome,
  FiLogOut,
  FiArrowLeftCircle,
  FiArrowRightCircle,
} from "react-icons/fi";
import {
  FaUserMd,
  FaUserAlt,
  FaUserCircle,
  FaUsers,
  FaUserFriends,
  FaUser,
  FaUserCheck,
  FaBriefcase,
  FaUserSlash,
  FaUserLock,
  FaUserMinus,
  FaCommentSlash,
  FaVideo,
  FaPlayCircle,
  FaAd,
  FaVideoSlash,
  FaTrash,
  FaListOl,
  FaUserTag,
  FaPuzzlePiece,
  FaVolumeMute,
  FaUniversity,
  FaCheckCircle,
  FaTimesCircle,
  FaGem,
  FaBroadcastTower,
  FaEnvelope,
  FaComment,
  FaUserShield,
  FaSeedling,
  FaDice,
  FaBullhorn,
  FaPlay,
  FaCheck,
  FaExclamationTriangle,
  FaTimes,
  FaCertificate,
  FaGlobe,
  FaCity,
  FaGift,
  FaMoneyCheckAlt,
  FaBell,
  FaMobileAlt,
  FaExchangeAlt,
  FaRunning,
  FaLanguage,
  FaLock,
  FaFileContract,
  FaUsersCog,
  FaFileAlt,
  FaStream,
  FaBan,
  FaHome,
  FaChartLine,
} from "react-icons/fa";
import { MdPersonAddAlt1, MdReport, MdRssFeed, MdOutlineSupportAgent } from "react-icons/md";
import "react-pro-sidebar/dist/css/styles.css";
import useAuth from "../../useAuth";
import Verifyauth from "../../verifyauth";
import { useNotifications } from "../../context/NotificationProvider";

import "./Sidebar.css";

const Sidebar = () => {
  // const { isAuth, userinfo } = Verifyauth();
  // const { user } = useAuth();

  const [menuCollapse, setMenuCollapse] = useState(false);
  const { user, isAuthenticated } = useAuth();
  const { totalCount, setIsDrawerOpen } = useNotifications();
  const menuIconClick = () => {
    menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
  };
  // console.log(user?.permissions, "all subfeaturesa");
  const hasUserAccess = user?.permissions?.Users || user?.role === "superadmin";
  const hasVideoAccess =
    user?.permissions?.Videos || user?.role === "superadmin";
  const hasBankTransactionAccess =
    user?.permissions?.["Bank TranSaction"] || user?.role === "superadmin";
  const hasDiamondTransactionAccess =
    user?.permissions?.["Diamond Transaction"] || user?.role === "superadmin";
  const hasPromotions =
    user?.permissions?.Promotions || user?.role === "superadmin";
  const hasVerification =
    user?.permissions?.Verification || user?.role === "superadmin";
  const hasCountries =
    user?.permissions?.Countries || user?.role === "superadmin";
  const hasCities = user?.permissions?.Cities || user?.role === "superadmin";
  const hasGifts = user?.permissions?.Gifts || user?.role === "superadmin";
  const hasWithdrawalRequest =
    user?.permissions?.["Withdrawal request"] || user?.role === "superadmin";
  const hasNotification =
    user?.permissions?.Notification || user?.role === "superadmin";
  const hasDollarDiamondrate =
    user?.permissions?.["Dollar Diamond rate"] || user?.role === "superadmin";

  const hasHobbies = user?.permissions?.Hobbies || user?.role === "superadmin";
  const hasOccupations =
    user?.permissions?.Occupations || user?.role === "superadmin";
  const hasLanguages =
    user?.permissions?.Languages || user?.role === "superadmin";
  const hasAvatar = user?.permissions?.Avatar || user?.role === "superadmin";
  const hasPrivacyPolicy =
    user?.permissions?.["Privacy Policy"] || user?.role === "superadmin";
  const hasTermsCondition =
    user?.permissions?.["Terms Condition"] || user?.role === "superadmin";
  const hasFeedAccess = user?.permissions?.Feed || user?.role === "superadmin";
  return (
    <div className="header">
      <ProSidebar collapsed={menuCollapse}>
        <SidebarHeader>
          <div
            className="logotext"
            style={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <p style={{ fontSize: 25, margin: 0 }}>
              {menuCollapse ? <FaUserCircle /> : user?.first_name}
            </p>
            {!menuCollapse && (
              <p style={{ fontSize: 18, color: "#9da5b1", margin: "4px 0 0" }}>
                {user?.role}
              </p>
            )}

            {/* Notification Bell */}
            <div 
              onClick={() => setIsDrawerOpen(true)}
              style={{
                marginTop: '15px',
                cursor: 'pointer',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.1)',
                transition: 'background 0.2s ease'
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
            >
              <FaBell style={{ fontSize: '20px', color: totalCount > 0 ? '#ffc107' : '#fff' }} />
              {totalCount > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-2px',
                  right: '-2px',
                  backgroundColor: '#dc3545',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid #2b2b2b'
                }}>
                  {totalCount > 99 ? '99+' : totalCount}
                </span>
              )}
            </div>
          </div>

          <div className="closemenu" onClick={menuIconClick}>
            {menuCollapse ? <FiArrowRightCircle /> : <FiArrowLeftCircle />}
          </div>
        </SidebarHeader>

        <SidebarContent>
          <Menu iconShape="circle">
            <MenuItem active={true} icon={<FaHome />}>
              <Link to="/dashboard">Dashboard</Link>
            </MenuItem>

            {/* TODO: disable till sockets issue resolve from frontend */}
            {/* <SubMenu icon={<FaChartLine />} title="Analytics">
              <MenuItem icon={<FaChartLine />}>
                <Link to="/analytics/overview">Overview</Link>
              </MenuItem>
              <MenuItem icon={<FaChartLine />}>
                <Link to="/analytics/sessions">Sessions</Link>
              </MenuItem>
              <MenuItem icon={<FaChartLine />}>
                <Link to="/analytics/advanced">Advanced</Link>
              </MenuItem>
              <MenuItem icon={<FaChartLine />}>
                <Link to="/analytics/engagement">Engagement</Link>
              </MenuItem>
            </SubMenu> */}

            {hasUserAccess && (
              <SubMenu icon={<FaUsers />} title="Users">
                <MenuItem icon={<FaUserFriends />}>
                  <Link to="/users/all_users">All Users</Link>
                </MenuItem>

                <MenuItem icon={<FaChartLine />}>
                  <Link to="/user-analytics">User Analytics</Link>
                </MenuItem>

                <MenuItem icon={<FaUser />}>
                  <Link to="/users/basic_users">Basic Users</Link>
                </MenuItem>

                <MenuItem icon={<FaUserCheck />}>
                  <Link to="/users/premium_users">Premium Users</Link>
                </MenuItem>

                <MenuItem icon={<FaBriefcase />}>
                  <Link to="/users/business_users">Business Users</Link>
                </MenuItem>

                <MenuItem icon={<FaUserSlash />}>
                  <Link to="/users/reported_users">Reported Users</Link>
                </MenuItem>
                <MenuItem icon={<FaUserCircle />}>
                  <Link to="/users/reported_profiles">Reported Profiles</Link>
                </MenuItem>

                <MenuItem icon={<FaUserLock />}>
                  <Link to="/users/blocked_users">Blocked Users</Link>
                </MenuItem>
                <MenuItem icon={<FaUserMinus />}>
                  <Link to="/users/deletion_request">Deletion Request</Link>
                </MenuItem>
                <MenuItem icon={<FaCommentSlash />}>
                  <Link to="/users/muteprivatechat">Muted Private Chat</Link>
                </MenuItem>
                <MenuItem icon={<FaFileAlt />}>
                  <Link to="/data-exports">Data Exports</Link>
                </MenuItem>
              </SubMenu>
            )}

            {hasVideoAccess && (
              <SubMenu icon={<FaVideo />} title="Videos">
                <MenuItem icon={<FaPlayCircle />}>
                  <Link to="/videos/all_videos">All Videos</Link>
                </MenuItem>
                <MenuItem icon={<FaAd />}>
                  <Link to="/videos/adds">Adds</Link>
                </MenuItem>
                <MenuItem icon={<MdReport />}>
                  <Link to="/videos/reported_videos">Reported Videos</Link>
                </MenuItem>
                <MenuItem icon={<FaComment />}>
                  <Link to="/videos/reported_post_comments">
                    Video Comment Reports
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaCommentSlash />}>
                  <Link to="/videos/reported_post_comment_replies">
                    Comment Reply Reports
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaVideoSlash />}>
                  <Link to="/videos/blocked_videos">Blocked Videos</Link>
                </MenuItem>
                <MenuItem icon={<FaTrash />}>
                  <Link to="/videos/video_delection">
                    Video Delection Request
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaListOl />}>
                  <Link to="/videos/rankedvideo">Ranked Video</Link>
                </MenuItem>
                <MenuItem icon={<FaUserTag />}>
                  <Link to="/videos/profilerankvideo">
                    Profile Ranked Video
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaPuzzlePiece />}>
                  <Link to="/videos/all_adds">Custom Adds</Link>
                </MenuItem>
                <MenuItem active={true} icon={<FaCommentSlash />}>
                  <Link to="/videos/mutevideocomment"> Mute Video Comment</Link>
                </MenuItem>

                <MenuItem active={true} icon={<FaVolumeMute />}>
                  <Link to="/videos/muteVideoAudio"> Mute Video Audio</Link>
                </MenuItem>
              </SubMenu>
            )}

            {/* *********************feed section */}
            {hasFeedAccess && (
              <SubMenu icon={<MdRssFeed />} title="Feed">
                <MenuItem icon={<FaStream />}>
                  <Link to="/AllFeed">All Feed</Link>
                </MenuItem>
                <MenuItem icon={<MdReport />}>
                  <Link to="/feed/reported_posts">Post Reports</Link>
                </MenuItem>
                <MenuItem icon={<ImNewspaper />}>
                  <Link to="/feed/reported_picture_posts">
                    Picture Post Reports
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaComment />}>
                  <Link to="/feed/reported_picture_post_comments">
                    Picture Comment Reports
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaCommentSlash />}>
                  <Link to="/muteuser">Muted Comment User</Link>
                </MenuItem>
                <MenuItem icon={<FaBan />}>
                  <Link to="/blockFeed">Block Feed Info</Link>
                </MenuItem>
              </SubMenu>
            )}

            {/* <MenuItem active={true} icon={<FiHome />}>
            <Link to="/">Sound</Link>
          </MenuItem> */}

            {hasBankTransactionAccess && (
              <SubMenu icon={<FaUniversity />} title="Bank Transaction">
                <MenuItem icon={<FaCheckCircle />}>
                  <Link to="/bank_transactions/success">Success</Link>
                </MenuItem>
                <MenuItem icon={<FaTimesCircle />}>
                  <Link to="/bank_transactions/failure">Failure</Link>
                </MenuItem>
              </SubMenu>
            )}
            {hasDiamondTransactionAccess && (
              <SubMenu icon={<FaGem />} title="Diamond Transaction">
                {/* <MenuItem icon={<MdPersonAddAlt1 />}>
      <Link to="/diamond_transactions/all_transaction">All Transactions</Link>
    </MenuItem> */}
                <MenuItem icon={<FaVideo />}>
                  <Link to="/diamond_transactions/video_transaction">
                    Video
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaBroadcastTower />}>
                  <Link to="/diamond_transactions/live_transaction">Live </Link>
                </MenuItem>
                <MenuItem icon={<FaEnvelope />}>
                  <Link to="/diamond_transactions/messages_transaction">
                    Messages{" "}
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaComment />}>
                  <Link to="/diamond_transactions/comment_transaction">
                    Comments{" "}
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaUserShield />}>
                  <Link to="/diamond_transactions/admin_to_user_transation">
                    Admin{" "}
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaSeedling />}>
                  <Link to="/diamond_transactions/feed_rose_transation">
                    Feed Rose Transation{" "}
                  </Link>
                </MenuItem>
              </SubMenu>
            )}
            {
              // hasDiamondTransactionAccess &&
              <SubMenu icon={<FaDice />} title="Wheel Luck">
                {/* <MenuItem icon={<MdPersonAddAlt1 />}>
      <Link to="/diamond_transactions/all_transaction">All Transactions</Link>
    </MenuItem> */}
                <MenuItem icon={<FaListOl />}>
                  <Link to="/wheel_luck/transaction">Transactions</Link>
                </MenuItem>
              </SubMenu>
            }
            {hasPromotions && (
              <SubMenu icon={<FaBullhorn />} title="Promotions">
                {/* <MenuItem icon={<MdPersonAddAlt1 />}>
      <Link to="/promotions/all_promotions">All</Link>
    </MenuItem> */}
                <MenuItem icon={<FaPlay />}>
                  <Link to="/promotions/live_promotions">Live</Link>
                </MenuItem>
                <MenuItem icon={<FaCheck />}>
                  <Link to="/promotions/accomplished_promotions">
                    Accomplished
                  </Link>
                </MenuItem>
                <MenuItem icon={<FaExclamationTriangle />}>
                  <Link to="/promotions/reported_promotions">Reported</Link>
                </MenuItem>
                <MenuItem icon={<FaTimes />}>
                  <Link to="/promotions/failure_promotions">Failure</Link>
                </MenuItem>
              </SubMenu>
            )}

            {hasVerification && (
              <SubMenu icon={<FaCertificate />} title="Verification">
                <MenuItem active={true} icon={<FaListOl />}>
                  <Link to="/verification_request">
                    Admin Requests
                  </Link>
                </MenuItem>
                {/* <MenuItem active={true} icon={<BsListOl />}>
              <Link to="/Verification_document">Verification document</Link>
            </MenuItem> */}
                <MenuItem active={true} icon={<FaListOl />}>
                  <Link to="/document_data">Identity Verification</Link>
                </MenuItem>

                <MenuItem active={true} icon={<FaListOl />}>
                  <Link to="/verification_request_by_user">
                    User Requests
                  </Link>
                </MenuItem>

                <MenuItem active={true} icon={<FaListOl />}>
                  <Link to="/BadgeRequest">Badge Requests</Link>
                </MenuItem>
              </SubMenu>
            )}

            {hasCountries && (
              <MenuItem active={true} icon={<FaGlobe />}>
                <Link to="/countries">Countries</Link>
              </MenuItem>
            )}

            {hasCities && (
              <MenuItem active={true} icon={<FaCity />}>
                <Link to="/cities">Cities</Link>
              </MenuItem>
            )}

            {hasGifts && (
              <MenuItem active={true} icon={<FaGift />}>
                <Link to="/gifts">Gifts</Link>
              </MenuItem>
            )}

            {hasWithdrawalRequest && (
              <MenuItem active={true} icon={<FaMoneyCheckAlt />}>
                <Link to="/withdrawel_request">Withdrawal request</Link>
              </MenuItem>
            )}

            {hasNotification && (
              <SubMenu icon={<FaBell />} title="Notification">
                <MenuItem active={true} icon={<FaMobileAlt />}>
                  <Link to="/push_notification">Push Notification</Link>
                </MenuItem>
                <MenuItem active={true} icon={<FaEnvelope />}>
                  <Link to="/email_notification">Email</Link>
                </MenuItem>
              </SubMenu>
            )}

            {hasDollarDiamondrate && (
              <SubMenu icon={<FaExchangeAlt />} title="Dollar/Diamond rate">
                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/diamond_rate">Dollar/Diamond rate</Link>
                </MenuItem>
                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/all_diamond_rate_info">All Diamond Rate Info</Link>
                </MenuItem>
                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/diamond_rate_converstion">
                    Diamond Rate Converter
                  </Link>
                </MenuItem>
              </SubMenu>
            )}
            {hasHobbies && (
              <MenuItem active={true} icon={<FaRunning />}>
                <Link to="/hobbies">Hobbies</Link>
              </MenuItem>
            )}

            {hasOccupations && (
              <MenuItem active={true} icon={<FaBriefcase />}>
                <Link to="/occupations">Occupations</Link>
              </MenuItem>
            )}

            {hasLanguages && (
              <MenuItem active={true} icon={<FaLanguage />}>
                <Link to="/languages">Languages</Link>
              </MenuItem>
            )}

            {hasAvatar && (
              <MenuItem active={true} icon={<FaUserCircle />}>
                <Link to="/avatar">Avatar</Link>
              </MenuItem>
            )}

            {hasPrivacyPolicy && (
              <MenuItem active={true} icon={<FaLock />}>
                <Link to="/privacy_policy">Privacy Policy</Link>
              </MenuItem>
            )}

            {hasTermsCondition && (
              <MenuItem active={true} icon={<FaFileContract />}>
                <Link to="/terms_and_conditions">Terms & Conditions</Link>
              </MenuItem>
            )}

            {hasTermsCondition && (
              <MenuItem active={true} icon={<MdOutlineSupportAgent />}>
                <Link to="/help_and_support">Help & Support</Link>
              </MenuItem>
            )}

            {hasTermsCondition && <MenuItem icon={<FaHome />}><Link to="/website_content">Website Content</Link></MenuItem>}

            {user?.role === "superadmin" ? (
              <SubMenu icon={<FaUsersCog />} title="Employee">
                <MenuItem active={true} icon={<FaUsersCog />}>
                  <Link to="/employee">Employee</Link>
                </MenuItem>
                <MenuItem active={true} icon={<FaUsersCog />}>
                  <Link to="/updatepermission">Update Permission</Link>
                </MenuItem>
              </SubMenu>
            ) : null}

            {user?.role === "superadmin" ? (
              <SubMenu icon={<FaUser />} title="Profile">
                <MenuItem active={true} icon={<FaUser />}>
                  <Link to="/profile"> Your Profile</Link>
                </MenuItem>

                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/profile/superadmmin_employees_transaction">
                    {" "}
                    {user?.role === "superadmin" ? "Employees" : "My"}{" "}
                    Transactions
                  </Link>
                </MenuItem>

                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/profile/superadmin_my_transaction">
                    {" "}
                    My Transactions
                  </Link>
                </MenuItem>
                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/profile/AllAdminEmployeeTransation">
                    {" "}
                    All Admin Employee Transation
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to={`/viewprofile/${user.id}`}></Link>
                </MenuItem>
              </SubMenu>
            ) : null}

            {/* {user?.role === 'admin' ? (
       <SubMenu icon={<ImNewspaper />} title="Profile">

              <MenuItem active={true} icon={<FiHome />}>
                <Link to="/adminProfile"> Profile</Link>
              </MenuItem>
              <MenuItem active={true} icon={<FiHome />}>
                <Link to="/adminemployetransation">All Transation</Link>
              </MenuItem>
              </SubMenu>

            ) : null}


            {user?.role === 'manager' ? (
              <MenuItem active={true} icon={<FiHome />}>
                <Link to="/managerProfile">Manager Profile</Link>
              </MenuItem>
            ) : null}

            {user?.role === 'assistant manager' ? (
              <MenuItem active={true} icon={<FiHome />}>
                <Link to="/assistantManagerProfile">Assistant Manager </Link>
              </MenuItem>
            ) : null} */}

            {["admin", "manager", "assistant manager"].includes(user?.role) && (
              <SubMenu icon={<FaUser />} title="Profile">
                {/* Profile Tab for all roles */}
                <MenuItem active={true} icon={<FaUser />}>
                  <Link to="/adminProfile">
                    {user?.role === "admin"
                      ? "Admin Profile"
                      : user?.role === "manager"
                        ? "Manager Profile"
                        : user?.role === "assistant manager"
                          ? "Assistant Manager"
                          : "Profile"}
                  </Link>
                </MenuItem>

                {/* All Transaction Tab (Visible to all roles) */}
                <MenuItem active={true} icon={<FaExchangeAlt />}>
                  <Link to="/adminemployetransation">All Transaction</Link>
                </MenuItem>
              </SubMenu>
            )}

            <SubMenu icon={<FaFileAlt />} title="Generate Report">
              {/* <MenuItem icon={<RiFileAddLine />}>
                <Link to="/generate_reports/new_reports">New Reports</Link>
              </MenuItem> */}
              <MenuItem icon={<FaFileAlt />}>
                <Link to="/generate_reports/all_reports">All Reports</Link>
              </MenuItem>
              {/* <MenuItem icon={<FcCalendar />}>
                <Link to="/generate_reports/recent_reports">Recent Report</Link>
              </MenuItem> */}
            </SubMenu>
          </Menu>
        </SidebarContent>
        <SidebarFooter>
          <Menu iconShape="square">
            <MenuItem icon={<FiLogOut />}>
              <Link to="/logout">Logout</Link>
            </MenuItem>
          </Menu>
        </SidebarFooter>
      </ProSidebar>
    </div>
  );
};

export default Sidebar;
